/* eslint-disable */


/**
 * Create styles for `<OrderGroup />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderGroup />` styles
 */
const orderGroupStyles = ({ theme }) => ({
  groupContainer: {
    backgroundColor: `inherit`,
    marginBottom: `70px`,
  },
  spaceBetween: {
    paddingBottom: theme.spacing(1),
    paddingTop: 0,
  },
  subHeader: {
    padding: 0,
    marginLeft: -theme.spacing(1) * 2,
    marginRight: -theme.spacing(1) * 2,
    paddingLeft: theme.spacing(1) * 2,
  },
  noOrdersText: {
    color: theme.palette.grey[400],
  },
});

export default orderGroupStyles;
